import { ApiProperty } from '@nestjs/swagger';
import { IsEnum, Matches } from 'class-validator';
import { DayOfWeek } from '../../../dayOfWeek';

export const SCHEDULE_INTERVAL_TIME_REGEXP = /^([01][0-9]|2[0-3]):([012345][0-9])$/;

export class CatalogItemScheduleIntervalRequest {
  @ApiProperty({ enum: DayOfWeek, enumName: 'DayOfWeek' })
  @IsEnum(DayOfWeek)
  dayOfWeek: DayOfWeek;

  @ApiProperty()
  @Matches(SCHEDULE_INTERVAL_TIME_REGEXP)
  from: string; // time HH:mm

  @ApiProperty()
  @Matches(SCHEDULE_INTERVAL_TIME_REGEXP)
  to: string; // time HH:mm
}
